import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSimCard2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="sim-card-2"><path d="M20 5.75V18.25C20 20.3211 18.3211 22 16.25 22H7.75C5.67893 22 4 20.3211 4 18.25V7.99264C4 6.99808 4.39509 6.04425 5.09835 5.34099L7.34099 3.09835C8.04425 2.39509 8.99808 2 9.99264 2H11.5V7.25C11.5 7.66421 11.8358 8 12.25 8C12.6642 8 13 7.66421 13 7.25V2H15.5V7.25C15.5 7.66421 15.8358 8 16.25 8C16.6642 8 17 7.66421 17 7.25V2.07501C18.7117 2.42247 20 3.93578 20 5.75Z" fill="currentColor"/></CentralIconBase>;
};

export default IconSimCard2;
